import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const KEY = "lura_admin_plan_sim";
const PlanPreviewContext = createContext(null);

// Simulación de plan SOLO ADMIN: cambia únicamente el gating/visualización de la UI.
// No toca la base de datos ni la suscripción real. Nunca aplica a cuentas de clientes.
export function PlanPreviewProvider({ children }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [plan, setPlanState] = useState(() => {
    try { return localStorage.getItem(KEY) || null; } catch (e) { return null; }
  });

  const setPreviewPlan = useCallback(async (p) => {
    if (user?.role !== "admin") return;
    try { if (p) localStorage.setItem(KEY, p); else localStorage.removeItem(KEY); } catch (e) { /* noop */ }
    setPlanState(p || null);
    try { await api.post("/admin/plan-simulation", { plan: p || null }); } catch (e) { /* auditoría best-effort */ }
  }, [user]);

  const active = isAdmin ? plan : null;
  return (
    <PlanPreviewContext.Provider value={{ previewPlan: active, setPreviewPlan, isAdmin }}>
      {children}
    </PlanPreviewContext.Provider>
  );
}

export const usePlanPreview = () =>
  useContext(PlanPreviewContext) || { previewPlan: null, setPreviewPlan: () => {}, isAdmin: false };
